export default function downloadFile(id, module, value, type = 'pdf', downloadFn = null) {
    // open right panel with loading
    this.openRightPanel('load', {name: value});

    // console.log('downloadFile', data);
    if (!id) {
        console.error('Chybí id souboru/záznamu');
    // return; //vyjimka email
    }
    if (!module) {
        console.error('Chybí modul souboru/záznamu');
    // return; //vyjimka email
    }

    this.filesXhr({
        action: 'filePreview',
        data: {id: id, module: module},
        success: (ret) => {
            if (ret.status == true) {
                const result = ret.message.data;
                if (result.token && result.type == 'local') {
                    const link = this.param.files + 'downloadFile/' + result.token;
                    // console.log(link );
                    console.log('link', link, downloadFn);
                    this.openRightPanel(type, {name: value, url: link, downloadFn: downloadFn, module: module, id: id});
                } else if (result.type == 'sharepoint') {
                    console.log('sharepoint', result);
                    this.openRightPanel(type, {name: value, url: result.url, downloadFn: downloadFn, module: module, id: id});
                }
            }
        },
        error: (ret) => {
            console.error('error', ret);
            this.openRightPanel('error', {data: []});
        },
    });
}
